import { createSlice } from '@reduxjs/toolkit';
import { getMarketersResponse } from '@repo/prospects-api';

export interface marketersDataType {
  selectedMarketer: {
    id: number;
    name: string;
  };
  marketers: {
    id: number;
    name: string;
  }[];
}

const initialState: marketersDataType = {
  selectedMarketer: {
    id: 0,
    name: '',
  },
  marketers: [],
};

export const marketerDataSlice = createSlice({
  name: 'marketerData',
  initialState,
  reducers: {
    setMarketersList: (state, action: { payload: getMarketersResponse[] }) => ({
      ...state,
      marketers: action.payload,
    }),
    setMarketerData: (state, action: { payload: getMarketersResponse }) => ({
      ...state,
      selectedMarketer: action.payload,
    }),
    resetMarketerData: () => initialState,
  },
});

export const { setMarketersList, setMarketerData, resetMarketerData } = marketerDataSlice.actions;

export default marketerDataSlice.reducer;
